import { GET_PROJECT_TYPES } from '../actions/types';

const projectTypes = (state = {}, action) => {
  switch (action.type) {
    case GET_PROJECT_TYPES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default projectTypes;